  <div class="cards-container">

  <h2 *ngIf="!healthcareservicesSpecialist">Não há especialistas disponíveis no momento</h2>

  <mat-card class="procedure-card">  
    <div class="col-sm-12 col-md-6 col-lg-5">
      <schedule-specialist-info *ngIf="healthcaservice"
          [practitioner]="practitioner"
          [location]="location"
          [index]="index"
          [healthcareservice]="healthcaservice"
          [practitionerRole]="practitionerRole"
      ></schedule-specialist-info> 
    </div>
    <div class="schedule-wrapper proc col-sm-12 col-md-6 col-lg-7" id="schedule-{{ index }}">
          <schedule-specialist *ngIf="healthcaservice"
            [index]="index"
            [healthcareservice]="healthcareservicesSpecialist"
            [practitioner_id]="practitioner?.practitioner_id ?? ''"
            [organization_id]="healthcareservicesSpecialist.organization_id"
            (onSelectedDatetime)="onSelectedDatetime($event, healthcareservicesSpecialist)"
        >
          </schedule-specialist>        
      </div>    

  </mat-card>

</div>
